/**
 * Pipeline for fetching employees by salary codes with position and employmentType lookups
 * @param {string[]} uniqueSalaryCodes - Array of unique salary codes to filter by
 * @returns {Array} MongoDB aggregation pipeline
 */
export function getEmployeePipeline(uniqueSalaryCodes) {
  return [
    {
      $match: {
        salaryCode: { $in: uniqueSalaryCodes }
      }
    },
    {
      $match: {
        $expr: {
          $in: ["*", "$acl.read"]
        }
      }
    },
    {
      $lookup: {
        from: "position_titles",
        localField: "position.id",
        foreignField: "_id",
        as: "positionLookup"
      }
    },
    {
      $lookup: {
        from: "employment_type",
        localField: "employmentType.id",
        foreignField: "_id",
        as: "employmentTypeLookup"
      }
    },
    {
      $project: {
        // acl is excluded from projection since we already filtered by it
        id: { $ifNull: ["$id", "$_id"] }, // Use id if exists, otherwise use _id
        _id: 0, // Exclude _id from output
        email: 1,
        employmentStatus: 1,
        salaryGrade: 1,
        salaryCode: 1,
        position: {
          $cond: {
            if: { $gt: [{ $size: "$positionLookup" }, 0] },
            then: {
              id: { $arrayElemAt: ["$positionLookup._id", 0] },
              position_title: { $arrayElemAt: ["$positionLookup.position_title", 0] }
            },
            else: null
          }
        },
        employmentType: {
          $cond: {
            if: { $gt: [{ $size: "$employmentTypeLookup" }, 0] },
            then: {
              id: { $arrayElemAt: ["$employmentTypeLookup._id", 0] },
              name: { $arrayElemAt: ["$employmentTypeLookup.name", 0] }
            },
            else: null
          }
        }
      }
    }
  ];
}

  // TEMPORARY: Commented out findObjectUseCase - using aggregate instead for better performance
  // const allEmployeesFind = await this.findObjectUseCase.execute("employees", {
  //   where: {
  //     salaryCode: { $in: uniqueSalaryCodes },
  //   },
  //   include: ["position", "employmentType"],
  //   keys: ["email", "position", "position.position_title", "employmentStatus", "salaryGrade", "salaryCode", "employmentType", "employmentType.name", "acl"],
  // });
